export default "__VITE_ASSET__93a24f94__"